































import { computed, defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import { UserAvatarStore, UserStore } from '@front-app/store/singletons/User';
import { Size } from '@front-app/components/constants';
import { useUsername } from '@front-app/hooks/useTranslate';
import { STATUS } from '@front-app/constants/state';
import LoaderState from '../LoaderState.vue';

export default defineComponent({
	components: {
		UserAvatar,
		TrButton,
		FontAwesomeIcon,
		LoaderState,
	},
	props: {
		userId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const userStore = UserStore.getInstance();
		const user = computed(() => userStore.getPartial(props.userId).value);
		const getUsername = useUsername(ctx);
		return {
			user,
			getUsername,
			STATUS,
			// Avatar
			fetchAvatar: UserAvatarStore.fetch,
			getAvatar: UserAvatarStore.get,
			Size,
		};
	},
});
